import DashView from "./components/Dash.vue";
import LoginView from "./components/Login.vue";
import NotFoundView from "./components/404.vue";

// Import Views - Dash
import DashboardView from "./components/views/Dashboard.vue";

import AddMakers from "./components/views/AddMakers.vue";
import AddTypes from "./components/views/AddTypes.vue";
import AddCars from "./components/views/AddCars.vue";
import AddVariants from "./components/views/AddVariants.vue";
import AddModelSeries from "./components/views/AddModelSeries.vue";

// Routes
const routes = [
  {
    path: "/login",
    component: LoginView,
  },
  {
    path: "/",
    component: DashView,
    children: [
      {
        path: "dashboard",
        alias: "",
        component: DashboardView,
        name: "Dashboard",
        meta: { description: "" },
      },
      {
        path: "makers",
        component: AddMakers,
        name: "All Makers",
        meta: { description: "" },
      },
      {
        path: "cars",
        component: AddCars,
        name: "All Cars",
        meta: { description: "" },
      },
      {
        path: "variants",
        component: AddVariants,
        name: "All Variants",
        meta: { description: "" },
      },
      {
        path: "types",
        component: AddTypes,
        name: "All Types",
        meta: { description: "" },
      },
      {
        path: "series",
        component: AddModelSeries,
        name: "All Model Series",
        meta: { description: "" },
      },
    ],
  },
  {
    // not found handler
    path: "*",
    component: NotFoundView,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js